import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { api } from '@consts/url.const';
import { Observable } from 'rxjs';
import { MapModels } from '@models/map.models';
import { BYPASS_AUTHENTICAION_TOKEN } from '../core/authentication-interceptor.service';

@Injectable()
export class MapService {
  constructor(private http: HttpClient) {}

  public getAllObjects(): Observable<MapModels.MapObject[]> {
    return this.http.get<MapModels.MapObject[]>(api.map.getObjects, { context: new HttpContext().set(BYPASS_AUTHENTICAION_TOKEN, true)});
  }

  public getMarkerPicture(id: string): Observable<MapModels.ObjectPicture[]> {
    return this.http.get<MapModels.ObjectPicture[]>(api.map.getPicture(id));
  }
}
